import { createSignal } from "solid-js";

import { DialogType } from "@/components/Dialogs/types";
import { useDialog } from "@/components/Dialogs/useDialog";
import { isMobile } from "@/lib/isMobile";
import { getActivityCfg } from "@/stores/activityStore.ts";
import { deviceInfo } from "@/stores/deviceStore";
import { userStore } from "@/stores/userStore.ts";
import {
  ActivityTypeEnum,
  RepeatActivityEnum,
} from "@/types/compontent/base/baseEnum";

type RepeatActivityContainBasicCfg = {
  active_img: string | null;
  active_text_type: number;
  atype: number;
  bonus_category: number;
  cfg: {
    // [key: string]: object;
    allow_app_types: number[];
    forbidden_close_popups: boolean;
    force_download: boolean;
    force_download_after_pay_cnt: number;
    h5_force_download: number;
    not_need_pay: boolean;
    pop_ups_type: number;
    repeatable_reward: boolean;
    reward: object;
    same_ip_count: number;
    store_app_force_download: number;
  };
  deny_label_type: number;
  deny_labels: number[]; // 若有具体结构可细化
  deny_pack: number[];
  deny_pack_type: number;
  etime: number;
  rules: Record<string, object>; // 若有具体规则结构可细化
  sort: number;
  status: boolean;
  stime: number;
};

export type RepeatCfgContainBasicMap = Record<
  string,
  RepeatActivityContainBasicCfg
>;

export const useRepeatActivityContainBasic = () => {
  const [repeatCfgContainBasic, setRepeatCfgContainBasic] =
    createSignal<RepeatCfgContainBasicMap>({});

  // const getRepeatActivityByAtype = async (atype: number) => {
  //   const details = await getAllActivityDetails();

  //   const item = details[atype] || {
  //     rewards: { list: [], count: 0, receive_point: 0 },
  //     details: { details: {} },
  //     activity_status: 0,
  //   };
  //   return item;
  // };

  // const forceShow = async () => {
  //   /* prettier-ignore */
  //   const webToAppCfg = repeatCfgContainBasicStore[RepeatActivityEnum.downloadPopup]?.cfg;
  //   /* prettier-ignore */
  //   const webToApp = await getRepeatActivityByAtype(RepeatActivityEnum.downloadPopup)

  //   const force_download = webToAppCfg?.force_download;
  //   /* prettier-ignore */
  //   const isPayOver = webToApp?.details?.details?.pay_cnt >= webToAppCfg?.force_download_after_pay_cnt;
  //   /* prettier-ignore */
  //   const forbidden_close_popups = webToAppCfg?.forbidden_close_popups || (!webToAppCfg?.forbidden_close_popups && !webToApp?.details?.details?.is_down_app);

  //   return forbidden_close_popups && isPayOver && force_download;
  // };

  const getWebToAppActivityAward = async () => {
    const { showDialog } = useDialog();

    // // 基础弹窗配置与app下载活动弹窗连动, 关闭基础弹窗配置后, 即便活动开启也不显示 app下载活动弹窗
    // const res = await GetIdxPoppups({
    //   data: {
    //     poppup_types: userStore.isLogin ? loginTypes : noLoginTypes,
    //     pack: userStore.userInfo?.pack_no ?? 0,
    //     general: userStore.userInfo?.general ?? 0,
    //     labels: userStore.userInfo?.labels || [],
    //   },
    //   isNeedLogin: Boolean(userStore.isLogin),
    // });

    // const webToAppElement = res?.poppups?.find(
    //   (item: any) => item.poppup_type === popupType.webToApp,
    // );
    if (deviceInfo?.app || deviceInfo?.pwa || !isMobile()) return;

    /* prettier-ignore */
    const webToAppCfg = repeatCfgContainBasic()[RepeatActivityEnum.downloadPopup]?.cfg;
    /* prettier-ignore */
    // const webToApp = await getRepeatActivityByAtype(RepeatActivityEnum.downloadPopup)
    const webToFirstDepositAppCfg = getActivityCfg(
      ActivityTypeEnum.appdownload
    )?.cfg;
    console.log("webToFirstDepositAppCfg");
    console.log(webToFirstDepositAppCfg?.pop_ups_type);
    // console.log(
    //   "webToFirstDepositAppCfg:",
    //   getActivityCfg(ActivityTypeEnum.appdownload),
    // );

    // const forcePopup =
    //   webToApp &&
    //   webToApp?.details?.details?.pay_cnt >=
    //     webToAppCfg?.force_download_after_pay_cnt &&
    //   webToAppCfg?.force_download;

    // if (forcePopup) {
    //   // 強制开启弹窗
    //   showDialog({ type: DialogType.AppDownloadActivity, data: { force: true } });
    // } else if (webToAppCfg.pop_ups_type !== 2) {
    //   showDialog({ type: DialogType.AppDownloadActivity });
    // }

    const showWebToApp =
      webToAppCfg?.pop_ups_type !== 2 && deviceInfo?.app_type === 0;

    const showWebToAppAndroidDownload =
      (webToFirstDepositAppCfg?.pop_ups_type === 1 ||
        (userStore.userInfo?.is_pay &&
          webToFirstDepositAppCfg?.pop_ups_type === 3)) &&
      deviceInfo?.app_type === 0;

    // console.log("showWebToApp", showWebToApp);
    // if (gameStore.gameLoaded) {
    //   // 游戏状态时，不直接弹出 APP 下载活动弹窗
    //   // 而是将其加入 DialogCenter 队列，等待访问首页时弹出

    //   // 导入 DialogCenter 实例
    //   const DialogSettingCenter = (
    //     await import("@/components/Dialogs/DialogCenter")
    //   ).default;

    //   // 将 APP 下载活动弹窗注册到队列中，设置最高优先级
    //   if (showWebToApp) {
    //     // 先移除已存在的APP下载弹窗，避免重复
    //     DialogSettingCenter.removeDialogById("web-to-app-game-loaded");

    //     DialogSettingCenter.registerDialog({
    //       execute: () => {
    //         showDialog({ type: DialogType.AppDownloadActivity });
    //       },
    //       options: {
    //         id: "web-to-app-game-loaded",
    //         sort: -999_999, // 最高优先级，确保第一个弹出
    //       },
    //     });

    //     // 立即执行队列，确保弹窗能够显示
    //     DialogSettingCenter.executeQueue();
    //   }

    //   return;
    // }

    if (showWebToApp) {
      // showDialog({ type: DialogType.AppDownloadActivity });
      showDialog({
        type: DialogType.ActivityIframe,
        data: { atype: ActivityTypeEnum.appdownload },
      });
    }
    if (!showWebToApp && showWebToAppAndroidDownload) {
      // showDialog({ type: DialogType.AppDownloadActivity });
      showDialog({
        type: DialogType.ActivityIframe,
        data: { atype: ActivityTypeEnum.appdownload },
      });
    }

    // if (webToApp) {
    //   const webToAppDetails = webToApp?.details || {};

    //   if (webToAppDetails.ok) {
    //     // useDoRepeatActive(
    //     //   { body: { atype: RepeatActivity.RepeatWebToApp } },
    //     //   (res: any) => {
    //     //     if (res.data?.status == 1) {
    //     //       const { $t }: any = useNuxtApp()
    //     //       let point = useRepeatActivityStore().webToApp?.cfg?.reward?.point
    //     //       if (point) {
    //     //         useDialogStore().open({
    //     //           title: $t('TIP201'),
    //     //           text: $t('TIP408', { symbol: '', value: configStore.renderFiatOrPlatCoinSymbol(point, false, true) }),
    //     //           cancel_text: false,
    //     //           ok_text: $t('AC0015'),
    //     //         })
    //     //       }
    //     //       this.updateUserWallets()
    //     //       this.getDetailsV2([RepeatActivity.RepeatWebToApp])
    //     //     }
    //     //   },
    //     //   (err: any) => {}
    //     // )
    //   }
    // }
  };

  return {
    repeatCfgContainBasic,
    setRepeatCfgContainBasic,

    // app 下载活动使用
    getWebToAppActivityAward,
  };
};
